import script from "./AgrupacionesExperienciasLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AgrupacionesExperienciasLanding.vue?vue&type=script&setup=true&lang=js"

import "./AgrupacionesExperienciasLanding.vue?vue&type=style&index=0&id=2974ea6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2974ea6c"]])

export default __exports__